module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/valentines-day/"},"excerpt":"Valentine’s Day is only a couple of weeks away. Remember when you bought your honey that new ironing board? It didn’t go over so well, did…","timeToRead":1,"frontmatter":{"title":"Valentine's Day is Coming!","tags":["birds","holidays","romance"]}}}]}},"pathContext":{"tag":"holidays"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-holidays.json
// module id = 764
// module chunks = 264086094094354